import moment from "moment";
import produce from "immer";

/**
 * This is responsible to convert data from api
 * to a format in our store.
 */

export const guestPersonalDetails = (guest) => {
    return {
        first_name: guest?.first_name || '',
        last_name: guest?.last_name || '',
        email: guest?.email || '',
        phone: guest?.phone || '',
        company: guest?.company || '',
        job_title: guest?.job_title || '',
    }
}

export const guestEmergencyContact = (guest) => {
    return {
        first_name: guest?.emergency_contact?.first_name || '',
        last_name: guest?.emergency_contact?.last_name || '',
        relationship: guest?.emergency_contact?.relationship || '',
        phone: guest?.emergency_contact?.phone || '',
    }
}

export const guestSpecialRequirements = (guest) => {
    return {
        dietary: guest?.dietaries?.map(d => d.id),
        medical_needs: !!guest?.requirement?.medical_needs,
        medical_comments: guest?.requirement?.medical_comments || '',
        wheelchair: !!guest?.requirement?.wheelchair,
        mobility_comments: guest?.requirement?.mobility_comments || '',
        other_dietary: guest?.requirement?.other_dietary || '',
    }
}

export const guestHotelRooms = (guest) => {

    let roomData = [];

    if (guest.hotel_rooms && guest.hotel_rooms.length) {
        roomData = produce(guest.hotel_rooms, (draft) => {
            draft.map((room) => {

                room.date_from = room.date_from ? moment(room.date_from) : null;
                room.date_to = room.date_to ? moment(room.date_to) : null;

                return room;
            });
        });
    }

    return {
        roomData: roomData,
        hotel_required: !!guest.requirement.hotel_required,
        hotel_comments: guest.requirement.hotel_comments || '',
        hotel_justification: guest.requirement.hotel_justification || ''
    }
}

const guestFlight = (flight) => {

    if (!flight) {
        return {};
    }

    return {
        airline: flight.airline || '',
        comments: flight.comments || '',
        flightNumber: flight.flight_number || '',
        stopOvers: flight.stopovers || '',
        airportTransferToCity: flight.airport_transfer_to_city,
        from: {
            date: flight.departure_date ? moment(flight.departure_date) : null,
            time: flight.departure_time ? moment(flight.departure_time) : null,
            location: flight.departure_location,
            terminal: flight.departure_terminal,
        },
        to: {
            date: flight.arrival_date ? moment(flight.arrival_date) : null,
            time: flight.arrival_time ? moment(flight.arrival_time) : null,
            location: flight.arrival_location,
            terminal: flight.arrival_terminal
        },
    }
};

const guestTrain = (train) => {
    if (!train) { return {}; }

    return {
        arrival_station: train.arrival_station || '',
        arrival_date: train.arrival_date ? moment(train.arrival_date) : null,
        arrival_time: train.arrival_time ? moment(train.arrival_time) : null,
        departure_station: train.departure_station || '',
        departure_date: train.departure_date ? moment(train.departure_date) : null,
        departure_time: train.departure_time ? moment(train.departure_time) : null,
        comments: train.comments || '',
    }
};

const guestCar = (car) => {

    if (!car) {
        return {};
    }

    return {
        car_registration_number: car.car_registration_number || '',
        arrival_date: car.arrival_date ? moment(car.arrival_date) : null,
        arrival_time: car.arrival_time ? moment(car.arrival_time) : null,
        departure_date: car.departure_date ? moment(car.departure_date) : null,
        departure_time: car.departure_time ? moment(car.departure_time) : null,
        need_parking: !!car.need_parking,
        comments: car.comments || '',
    }
};

export const guestTravel = (guest) => {
    return {
        travel_method: guest.requirement.travel_method || 'flight',
        travel_circuit_only: !!guest.requirement.travel_circuit_only,
        travel_enabled: !!guest.requirement.travel_enabled,
        travel_ground_transfers: !!guest.requirement.travel_ground_transfers,
        flight: {
            inbound: guestFlight(guest.inbound_flight),
            outbound: guestFlight(guest.outbound_flight),
        },
        train: guestTrain(guest.train),
        car: guestCar(guest.car)
    }
}

const guestFormData = (guest) => {
    return {
        personal_details: guestPersonalDetails(guest),
        special_requirements: guestSpecialRequirements(guest),
        hotel_rooms: guestHotelRooms(guest),
        travel: guestTravel(guest),
        emergency_contact: guestEmergencyContact(guest),
    }
}


export default guestFormData;
